var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        {
          staticClass: "skip-link sr-only-focusable",
          attrs: { href: "#main-content" }
        },
        [_vm._v(" Pular para o conteúdo principal ")]
      ),
      _c("b-img", {
        staticClass: "bkg_img",
        attrs: {
          fluid: "",
          src: require("@/assets/images/pages/graphic-1.png")
        }
      }),
      _c(
        "div",
        {
          style: _vm.dynamicStyles,
          attrs: { id: "portal-cebas-credentialing-public" }
        },
        [
          _c(
            "main",
            { attrs: { id: "main-content", role: "main", tabindex: "-1" } },
            [
              _c(
                "b-card",
                {
                  staticClass: "h-full",
                  class: _vm.primaryVariant
                    ? "header-bg-" + _vm.primaryVariant
                    : "header-bg-dynamic",
                  attrs: { "no-body": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function() {
                        return [
                          _c(
                            "span",
                            { staticClass: "text-white text-lg font-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.portalCebasConfig.title_page ||
                                    "Credenciamento CEBAS"
                                )
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "footer",
                      fn: function() {
                        return [
                          _c("page-footer", { attrs: { showLoginLink: false } })
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  !_vm.hasCebasCredentialing
                    ? _c(
                        "b-container",
                        {
                          staticClass: "p-4",
                          class: _vm.primaryVariant
                            ? "bg-" + _vm.primaryVariant
                            : "bg-dynamic-primary",
                          attrs: { fluid: "" }
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c("b-img", {
                                    attrs: {
                                      center: "",
                                      thumbnail: "",
                                      fluid: "",
                                      src: require("@/assets/images/pages/404-2.png"),
                                      alt: "Página 404"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hasCebasCredentialing
                    ? _c("div", { staticClass: "pt-1 p-1" }, [
                        !_vm.formStarted
                          ? _c(
                              "div",
                              { staticClass: "initial-screen" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mb-4" },
                                  [
                                    _c("complex-editor-view", {
                                      attrs: {
                                        editor_data: _vm.infoPageContent,
                                        "read-only": true
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-card",
                                  {
                                    class: _vm.primaryVariant
                                      ? "border-" + _vm.primaryVariant
                                      : "border-dynamic-primary"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-center" },
                                      [
                                        _c(
                                          "h5",
                                          {
                                            class: _vm.primaryVariant
                                              ? "card-title text-" +
                                                _vm.primaryVariant +
                                                " mb-4"
                                              : "card-title text-dynamic-primary mb-4"
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "feather icon-info mr-2"
                                            }),
                                            _vm._v(" Antes de Prosseguir ")
                                          ]
                                        ),
                                        _c(
                                          "b-alert",
                                          {
                                            staticClass: "text-left mb-4",
                                            attrs: { variant: "info", show: "" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "alert-body" },
                                              [
                                                _c(
                                                  "h6",
                                                  {
                                                    staticClass: "alert-heading"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "feather icon-alert-circle mr-1"
                                                    }),
                                                    _vm._v(" Importante! ")
                                                  ]
                                                ),
                                                _c("hr"),
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-2" },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "• Tempo estimado:"
                                                      )
                                                    ]),
                                                    _vm._v(
                                                      " 15-20 minutos para completar todo o processo "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-2" },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "• Documentos necessários:"
                                                      )
                                                    ]),
                                                    _vm._v(
                                                      " Tenha em mãos todos os documentos em formato PDF "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-2" },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        "• Dados obrigatórios:"
                                                      )
                                                    ]),
                                                    _vm._v(
                                                      " Todos os campos indicados como obrigatórios devem ser preenchidos "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-0" },
                                                  [
                                                    _c("strong", [
                                                      _vm._v("• Salvamento:")
                                                    ]),
                                                    _vm._v(
                                                      " Você pode pausar e retomar o preenchimento a qualquer momento "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "verification-section"
                                          },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass: "checkbox-wrapper"
                                              },
                                              [
                                                _c(
                                                  "b-form-checkbox",
                                                  {
                                                    staticClass:
                                                      "custom-checkbox-large",
                                                    class: !_vm.primaryVariant
                                                      ? "checkbox-dynamic-primary"
                                                      : "",
                                                    attrs: {
                                                      state: _vm.getInitialFieldState(
                                                        "dataVeracity"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.initialAcceptance
                                                          .dataVeracity,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.initialAcceptance,
                                                          "dataVeracity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "initialAcceptance.dataVeracity"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "checkbox-text"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Declaro que todas as informações que serão fornecidas durante este processo são "
                                                        ),
                                                        _c(
                                                          "strong",
                                                          {
                                                            class: _vm.primaryVariant
                                                              ? "text-" +
                                                                _vm.primaryVariant
                                                              : "text-dynamic-primary"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "verdadeiras e correspondem à realidade"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          ", estando ciente de que a prestação de informações falsas constitui crime. "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c("b-form-invalid-feedback", [
                                                  _vm._v(
                                                    " Você deve confirmar a veracidade das informações para prosseguir "
                                                  )
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-form-group",
                                              {
                                                staticClass:
                                                  "checkbox-wrapper mt-3"
                                              },
                                              [
                                                _c(
                                                  "b-form-checkbox",
                                                  {
                                                    staticClass:
                                                      "custom-checkbox-large",
                                                    class: !_vm.primaryVariant
                                                      ? "checkbox-dynamic-primary"
                                                      : "",
                                                    attrs: {
                                                      state: _vm.getInitialFieldState(
                                                        "dataCollection"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.initialAcceptance
                                                          .dataCollection,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.initialAcceptance,
                                                          "dataCollection",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "initialAcceptance.dataCollection"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "checkbox-text"
                                                      },
                                                      [
                                                        _vm._v(" Autorizo o "),
                                                        _c(
                                                          "strong",
                                                          {
                                                            class: _vm.primaryVariant
                                                              ? "text-" +
                                                                _vm.primaryVariant
                                                              : "text-dynamic-primary"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "tratamento dos meus dados pessoais"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " conforme a Lei Geral de Proteção de Dados (LGPD), para fins de análise desta solicitação de credenciamento. "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c("b-form-invalid-feedback", [
                                                  _vm._v(
                                                    " Você deve autorizar o tratamento dos dados para prosseguir "
                                                  )
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "action-buttons mt-4"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "d-grid gap-4" },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "px-5",
                                                    class: !_vm.primaryVariant
                                                      ? "btn-dynamic-primary"
                                                      : "",
                                                    attrs: {
                                                      variant:
                                                        _vm.primaryVariant,
                                                      size: "lg",
                                                      disabled: !_vm.canStartProcess
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.showStartCredentialingModal
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "feather icon-play mr-2"
                                                    }),
                                                    _vm._v(
                                                      " Iniciar Credenciamento "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-muted"
                                                      },
                                                      [_vm._v("ou")]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "px-5",
                                                    class: !_vm.primaryVariant
                                                      ? "btn-outline-dynamic-primary"
                                                      : "",
                                                    attrs: {
                                                      variant:
                                                        "outline-primary",
                                                      size: "lg"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.showContinueCredentialingModal
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "feather icon-refresh-cw mr-2"
                                                    }),
                                                    _vm._v(
                                                      " Continuar Credenciamento "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-muted mt-3 mb-0"
                                              },
                                              [
                                                _c("small", [
                                                  _c("i", {
                                                    staticClass:
                                                      "feather icon-shield mr-1"
                                                  }),
                                                  _vm._v(
                                                    " Seus dados estão protegidos e serão utilizados apenas para este processo "
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "wizard-container main-content-container"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    ref: "badgeContainer",
                                    staticClass:
                                      "d-flex justify-content-between align-items-center mb-3"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-items-center"
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "mr-2",
                                            attrs: {
                                              variant: "outline-secondary",
                                              size: "sm"
                                            },
                                            on: {
                                              click: _vm.backToInitialScreen
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "feather icon-arrow-left mr-1"
                                            }),
                                            _vm._v(" Voltar ao Início ")
                                          ]
                                        ),
                                        _vm.isDevelopment
                                          ? _c(
                                              "b-button",
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  variant: "outline-warning",
                                                  size: "sm",
                                                  title:
                                                    "Preencher com dados de teste (apenas em desenvolvimento)"
                                                },
                                                on: {
                                                  click: _vm.fillWithMockData
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-zap mr-1"
                                                }),
                                                _vm._v(" Mock Data ")
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.isDevelopment
                                          ? _c(
                                              "b-button",
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  variant: "outline-info",
                                                  size: "sm",
                                                  title:
                                                    "Alternar entre conteúdo padrão e da API (apenas em desenvolvimento)"
                                                },
                                                on: {
                                                  click:
                                                    _vm.testInfoPageBehavior
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-toggle-right mr-1"
                                                }),
                                                _vm._v(" Info Page ")
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.isDevelopment
                                          ? _c(
                                              "b-button",
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  variant: "outline-secondary",
                                                  size: "sm",
                                                  title:
                                                    "Ver dados que serão enviados para API (apenas em desenvolvimento)"
                                                },
                                                on: { click: _vm.debugFormData }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-code mr-1"
                                                }),
                                                _vm._v(" Debug API ")
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.isDevelopment
                                          ? _c(
                                              "b-button",
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  variant: _vm.autoSaveEnabled
                                                    ? "outline-success"
                                                    : "outline-danger",
                                                  size: "sm",
                                                  title:
                                                    "Auto-save está " +
                                                    (_vm.autoSaveEnabled
                                                      ? "ativo"
                                                      : "inativo") +
                                                    " - clique para alternar"
                                                },
                                                on: {
                                                  click: _vm.toggleAutoSave
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "mr-1",
                                                  class: _vm.autoSaveEnabled
                                                    ? "feather icon-check"
                                                    : "feather icon-x"
                                                }),
                                                _vm._v(" Auto-Save ")
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-items-center"
                                      },
                                      [
                                        _c(
                                          "b-badge",
                                          {
                                            staticClass: "px-3 py-2 mr-2",
                                            attrs: {
                                              variant:
                                                _vm.formData.status &&
                                                _vm.formData.status.color
                                                  ? _vm.formData.status.color
                                                  : "primary"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "feather icon-clock mr-1"
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formData.status &&
                                                    _vm.formData.status.label
                                                    ? _vm.formData.status.label
                                                    : "Processo Iniciado"
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _vm.isFormDisabled
                                          ? _c(
                                              "b-badge",
                                              {
                                                staticClass: "px-2 py-1 mr-2",
                                                attrs: {
                                                  variant: "secondary",
                                                  title:
                                                    "Formulário em modo somente leitura - navegação permitida apenas para visualização"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-eye mr-1"
                                                }),
                                                _vm._v(" Visualização ")
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.isSaving && !_vm.floatingSavingBadge
                                          ? _c(
                                              "b-badge",
                                              {
                                                staticClass: "px-2 py-1",
                                                attrs: {
                                                  variant: "warning",
                                                  title:
                                                    "Salvando dados na API..."
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-upload spinning mr-1"
                                                }),
                                                _vm._v(" Salvando... ")
                                              ]
                                            )
                                          : _vm.lastSaveTime &&
                                            !_vm.isFormDisabled
                                          ? _c(
                                              "b-badge",
                                              {
                                                staticClass: "px-2 py-1",
                                                attrs: {
                                                  variant: "success",
                                                  title:
                                                    "Último salvamento: " +
                                                    _vm.formatLastSaveTime()
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-check mr-1"
                                                }),
                                                _vm._v(" Salvo ")
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm.isSaving && _vm.floatingSavingBadge
                                  ? _c(
                                      "b-badge",
                                      {
                                        staticClass:
                                          "floating-saving-badge px-2 py-1",
                                        style: _vm.getFloatingBadgeStyle(),
                                        attrs: {
                                          title: "Salvando dados na API..."
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "feather icon-upload spinning mr-1"
                                        }),
                                        _vm._v(" Salvando... ")
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "form-wizard",
                                  {
                                    ref: "credentialingWizard",
                                    staticClass: "steps-transparent mb-3",
                                    attrs: {
                                      color: _vm.primaryColor,
                                      title: null,
                                      subtitle: null,
                                      "finish-button-text":
                                        _vm.finishButtonText,
                                      "next-button-text": _vm.nextButtonText,
                                      "back-button-text": _vm.backButtonText,
                                      "finish-button-disabled":
                                        _vm.isFormDisabled,
                                      "enable-all-nav": !_vm.isFormDisabled
                                    },
                                    on: {
                                      "on-complete":
                                        _vm.submitCredentialingForm,
                                      "on-change": _vm.handleStepChange
                                    }
                                  },
                                  [
                                    _c(
                                      "tab-content",
                                      {
                                        attrs: {
                                          title: _vm.getStepTitle("basic_data"),
                                          icon: _vm.getStepIcon("basic_data"),
                                          "before-change": _vm.validateBasicData
                                        }
                                      },
                                      [
                                        _c("basic-data-step", {
                                          attrs: {
                                            "form-data": _vm.formData.basicData,
                                            errors: _vm.getBasicDataErrors(),
                                            "primary-variant":
                                              _vm.primaryVariant,
                                            disabled: _vm.isFormDisabled
                                          },
                                          on: {
                                            "update:form-data":
                                              _vm.updateBasicData
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "tab-content",
                                      {
                                        attrs: {
                                          title: "Documentação Jurídica",
                                          icon: "feather icon-file-text",
                                          "before-change":
                                            _vm.validateJuridicalDocumentation
                                        }
                                      },
                                      [
                                        _c("JuridicalDocumentationStep", {
                                          ref: "juridicalDocumentationStep",
                                          attrs: {
                                            "form-data":
                                              _vm.formData
                                                .juridicalDocumentation,
                                            errors: _vm.getJuridicalDocumentationErrors(),
                                            "primary-variant":
                                              _vm.primaryVariant,
                                            disabled: _vm.isFormDisabled
                                          },
                                          on: {
                                            "update:form-data":
                                              _vm.updateJuridicalDocumentation,
                                            "upload-document":
                                              _vm.handleUploadJuridicalDocumentation,
                                            "remove-document":
                                              _vm.handleRemoveJuridicalDocumentation
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "tab-content",
                                      {
                                        attrs: {
                                          title:
                                            "Dados Econômicos e Operacionais",
                                          icon: "feather icon-bar-chart",
                                          "before-change":
                                            _vm.validateEconomicOperationalData
                                        }
                                      },
                                      [
                                        _c("EconomicOperationalDataStep", {
                                          attrs: {
                                            "form-data":
                                              _vm.formData
                                                .economicOperationalData,
                                            errors: _vm.getEconomicOperationalDataErrors(),
                                            disabled: _vm.isFormDisabled
                                          },
                                          on: {
                                            "update:form-data":
                                              _vm.updateEconomicOperationalData,
                                            "upload-document":
                                              _vm.handleUploadEconomicOperationalData,
                                            "remove-document":
                                              _vm.handleRemoveEconomicOperationalData
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "tab-content",
                                      {
                                        attrs: {
                                          title: "Unidades Vinculadas",
                                          icon: "feather icon-link",
                                          "before-change":
                                            _vm.validateLinkedInstitutions
                                        }
                                      },
                                      [
                                        _c("LinkedInstitutionsStep", {
                                          ref: "linkedInstitutionsStep",
                                          attrs: {
                                            "form-data":
                                              _vm.formData.linkedInstitutions,
                                            errors: _vm.getLinkedInstitutionsErrors(),
                                            disabled: _vm.isFormDisabled
                                          },
                                          on: {
                                            "update:form-data":
                                              _vm.updateLinkedInstitutions,
                                            "add-institution":
                                              _vm.handleAddInstitution,
                                            "remove-institution":
                                              _vm.handleRemoveInstitution
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "tab-content",
                                      {
                                        attrs: {
                                          title: "Anexos Complementares",
                                          icon: "feather icon-paperclip",
                                          "before-change":
                                            _vm.validateAdditionalAttachments
                                        }
                                      },
                                      [
                                        _c("AdditionalAttachmentsStep", {
                                          attrs: {
                                            "form-data":
                                              _vm.formData
                                                .additionalAttachments,
                                            errors: _vm.getAdditionalAttachmentsErrors(),
                                            link: _vm.link,
                                            "credentialing-id":
                                              _vm.credentialingId,
                                            disabled: _vm.isFormDisabled
                                          },
                                          on: {
                                            "update:form-data":
                                              _vm.updateAdditionalAttachments,
                                            "upload-document":
                                              _vm.handleUploadAdditionalAttachments,
                                            "remove-document":
                                              _vm.handleRemoveAdditionalAttachments
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "tab-content",
                                      {
                                        attrs: {
                                          title: "Revisão",
                                          icon: "feather icon-check-circle"
                                        }
                                      },
                                      [
                                        _c("ReviewStep", {
                                          attrs: {
                                            "basic-data":
                                              _vm.formData.basicData,
                                            "juridical-documentation":
                                              _vm.formData
                                                .juridicalDocumentation,
                                            "economic-operational-data":
                                              _vm.formData
                                                .economicOperationalData,
                                            "linked-institutions":
                                              _vm.formData.linkedInstitutions,
                                            "additional-attachments":
                                              _vm.formData
                                                .additionalAttachments,
                                            "accept-terms":
                                              _vm.formData.acceptTerms,
                                            errors: _vm.getReviewErrors(),
                                            "activity-areas": _vm.activityAreas,
                                            "organization-sizes":
                                              _vm.organizationSizes,
                                            "primary-variant":
                                              _vm.primaryVariant,
                                            disabled: _vm.isFormDisabled
                                          },
                                          on: {
                                            "update:accept-terms":
                                              _vm.updateAcceptTerms,
                                            "show-terms": function($event) {
                                              _vm.showTerms = true
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                      ])
                    : _vm._e(),
                  _c(
                    "b-row",
                    { staticClass: "m-0" },
                    [_c("b-col", { attrs: { lg: "12" } })],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  attrs: {
                    title: "Termos e Condições de Uso",
                    size: "xl",
                    "hide-footer": "",
                    scrollable: ""
                  },
                  model: {
                    value: _vm.showTerms,
                    callback: function($$v) {
                      _vm.showTerms = $$v
                    },
                    expression: "showTerms"
                  }
                },
                [
                  _c("div", { staticClass: "terms-content" }, [
                    _c("div", { staticClass: "text-center mb-4" }, [
                      _c(
                        "h4",
                        {
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("Termos e Condições de Uso")]
                      ),
                      _c("h5", { staticClass: "text-muted" }, [
                        _vm._v("Sistema de Credenciamento CEBAS")
                      ]),
                      _c("hr")
                    ]),
                    _c("div", { staticClass: "text-justify" }, [
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("1. ACEITAÇÃO DOS TERMOS")]
                      ),
                      _c("p", [
                        _vm._v(
                          " Ao utilizar este sistema de credenciamento CEBAS, você concorda integralmente com os presentes termos e condições de uso. Caso não concorde com qualquer disposição aqui prevista, não prossiga com a utilização do sistema. "
                        )
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("2. OBJETO E FINALIDADE")]
                      ),
                      _c("p", [
                        _vm._v(
                          " Este sistema destina-se exclusivamente ao processo de solicitação de Certificado de Entidade Beneficente de Assistência Social (CEBAS), conforme regulamentação vigente. O sistema permite o cadastro, envio de documentação e acompanhamento do processo de credenciamento. "
                        )
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("3. RESPONSABILIDADES DO USUÁRIO")]
                      ),
                      _c("p", [_vm._v("O usuário compromete-se a:")]),
                      _c("ul", { staticClass: "pl-4" }, [
                        _c("li", [
                          _vm._v(
                            "Fornecer informações verdadeiras, completas e atualizadas;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Manter a confidencialidade de suas credenciais de acesso;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Utilizar o sistema apenas para os fins previstos;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Responsabilizar-se pela veracidade de todos os documentos enviados;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Cumprir a legislação aplicável ao processo de credenciamento;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Não tentar violar a segurança do sistema ou acessar áreas restritas."
                          )
                        ])
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("4. PROTEÇÃO DE DADOS PESSOAIS")]
                      ),
                      _c("p", [
                        _vm._v(
                          " Em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018), informamos que: "
                        )
                      ]),
                      _c("ul", { staticClass: "pl-4" }, [
                        _c("li", [
                          _vm._v(
                            "Os dados pessoais coletados serão utilizados exclusivamente para o processo de credenciamento CEBAS;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "As informações serão tratadas com confidencialidade e segurança adequadas;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Os dados poderão ser compartilhados com órgãos competentes quando necessário ao processo;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Você tem direito de acesso, correção, exclusão e portabilidade de seus dados;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "O titular pode revogar o consentimento a qualquer tempo, observadas as obrigações legais."
                          )
                        ])
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("5. DOCUMENTAÇÃO E ARQUIVOS")]
                      ),
                      _c("p", [
                        _vm._v(
                          " Quanto à documentação enviada através do sistema: "
                        )
                      ]),
                      _c("ul", { staticClass: "pl-4" }, [
                        _c("li", [
                          _vm._v(
                            "Todos os documentos devem ser legíveis e em formato PDF;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "O usuário é responsável pela autenticidade dos documentos enviados;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Os arquivos são armazenados com segurança e podem ser acessados pelos órgãos competentes;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Documentos com vírus ou malware serão automaticamente rejeitados;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "O sistema não se responsabiliza por perda de dados devido a problemas técnicos do usuário."
                          )
                        ])
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("6. LIMITAÇÕES DE RESPONSABILIDADE")]
                      ),
                      _c("p", [
                        _vm._v(
                          " O sistema e seus responsáveis não se responsabilizam por: "
                        )
                      ]),
                      _c("ul", { staticClass: "pl-4" }, [
                        _c("li", [
                          _vm._v(
                            "Indisponibilidade temporária do sistema por manutenção ou problemas técnicos;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Decisões administrativas relacionadas ao processo de credenciamento;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Danos decorrentes do uso inadequado do sistema;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Perda de dados causada por falhas no equipamento ou conexão do usuário;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Atrasos no processo causados por documentação inadequada ou incompleta."
                          )
                        ])
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("7. PROPRIEDADE INTELECTUAL")]
                      ),
                      _c("p", [
                        _vm._v(
                          " Todo o conteúdo do sistema, incluindo textos, imagens, logos, código-fonte e funcionalidades, é protegido por direitos autorais e outras leis de propriedade intelectual. É vedada a reprodução, distribuição ou modificação sem autorização expressa. "
                        )
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("8. MODIFICAÇÕES DOS TERMOS")]
                      ),
                      _c("p", [
                        _vm._v(
                          " Estes termos podem ser modificados a qualquer tempo, sendo as alterações comunicadas através do próprio sistema. O uso continuado após as modificações implica na aceitação dos novos termos. "
                        )
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("9. PRAZO E RESCISÃO")]
                      ),
                      _c("p", [
                        _vm._v(
                          " O acesso ao sistema é concedido pelo prazo necessário à conclusão do processo de credenciamento. O acesso pode ser suspenso ou encerrado em caso de descumprimento destes termos ou conclusão do processo. "
                        )
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("10. LEGISLAÇÃO APLICÁVEL")]
                      ),
                      _c("p", [
                        _vm._v(
                          " Estes termos são regidos pela legislação brasileira, especialmente: "
                        )
                      ]),
                      _c("ul", { staticClass: "pl-4" }, [
                        _c("li", [
                          _vm._v("Lei nº 12.101/2009 (Lei do CEBAS);")
                        ]),
                        _c("li", [
                          _vm._v(
                            "Lei nº 13.709/2018 (Lei Geral de Proteção de Dados);"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Lei nº 12.965/2014 (Marco Civil da Internet);"
                          )
                        ]),
                        _c("li", [_vm._v("Código de Defesa do Consumidor;")]),
                        _c("li", [_vm._v("Demais normas aplicáveis ao setor.")])
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("11. CONTATO E SUPORTE")]
                      ),
                      _c("p", [
                        _vm._v(
                          " Para dúvidas, sugestões ou problemas técnicos relacionados ao sistema, entre em contato através dos canais oficiais disponibilizados na plataforma. "
                        )
                      ]),
                      _c(
                        "h6",
                        {
                          staticClass: "mt-4 mb-2",
                          class: _vm.primaryVariant
                            ? "text-" + _vm.primaryVariant
                            : "text-dynamic-primary"
                        },
                        [_vm._v("12. DECLARAÇÃO DE CIÊNCIA")]
                      ),
                      _c("p", [
                        _vm._v(" Ao aceitar estes termos, você declara que: ")
                      ]),
                      _c("ul", { staticClass: "pl-4" }, [
                        _c("li", [
                          _vm._v(
                            "Leu e compreendeu integralmente este documento;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Possui capacidade jurídica para assumir as obrigações aqui previstas;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Está autorizado a representar a entidade no processo de credenciamento;"
                          )
                        ]),
                        _c("li", [
                          _vm._v(
                            "Compromete-se a cumprir todas as disposições aqui estabelecidas."
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "alert alert-info mt-4" }, [
                        _c("div", { staticClass: "alert-body" }, [
                          _c("h6", { staticClass: "alert-heading" }, [
                            _c("i", { staticClass: "feather icon-info mr-1" }),
                            _vm._v(" Importante ")
                          ]),
                          _c("hr"),
                          _c("p", { staticClass: "mb-0" }, [
                            _c("strong", [
                              _vm._v("Data de última atualização:")
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(new Date().toLocaleDateString("pt-BR"))
                            ),
                            _c("br"),
                            _c("strong", [_vm._v("Versão:")]),
                            _vm._v(" 1.0"),
                            _c("br"),
                            _c("br"),
                            _vm._v(
                              " O processo de credenciamento CEBAS segue rigorosamente a legislação brasileira vigente. Certifique-se de que sua entidade atende a todos os requisitos legais antes de iniciar o processo. "
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              ),
              _c(
                "b-modal",
                {
                  attrs: {
                    title: "Continuar Credenciamento",
                    size: "md",
                    "hide-footer": ""
                  },
                  on: {
                    cancel: _vm.resetContinueModal,
                    hide: _vm.resetContinueModal
                  },
                  model: {
                    value: _vm.showContinueModal,
                    callback: function($$v) {
                      _vm.showContinueModal = $$v
                    },
                    expression: "showContinueModal"
                  }
                },
                [
                  _c("div", { staticClass: "text-center mb-3" }, [
                    _c("i", {
                      staticClass: "feather icon-search",
                      class: _vm.primaryVariant
                        ? "text-" + _vm.primaryVariant
                        : "text-dynamic-primary",
                      staticStyle: { "font-size": "2.5rem" }
                    }),
                    _c("h5", { staticClass: "mt-3" }, [
                      _vm._v("Recuperar Credenciamento")
                    ]),
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v(
                        " Digite o e-mail e o código de credenciamento recebido por e-mail "
                      )
                    ])
                  ]),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.searchExistingCredentialing($event)
                        }
                      }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "E-mail",
                                    "label-for": "continue-email",
                                    description:
                                      "Digite o mesmo e-mail informado no credenciamento anterior"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "continue-email",
                                      type: "email",
                                      placeholder: "seu@email.com",
                                      state: _vm.continueEmailValidation,
                                      size: "lg",
                                      required: ""
                                    },
                                    on: {
                                      input: _vm.validateContinueEmail,
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.searchExistingCredentialing(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.continueEmail,
                                      callback: function($$v) {
                                        _vm.continueEmail = $$v
                                      },
                                      expression: "continueEmail"
                                    }
                                  }),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(" E-mail válido é obrigatório ")
                                  ]),
                                  _c("b-form-valid-feedback", [
                                    _vm._v(" E-mail válido ")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "12" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Código de Credenciamento",
                                    "label-for": "continue-code",
                                    description:
                                      "Digite o código de 6 dígitos recebido por e-mail"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "######",
                                        expression: "'######'"
                                      }
                                    ],
                                    attrs: {
                                      id: "continue-code",
                                      placeholder: "000000",
                                      state: _vm.continueCodeValidation,
                                      size: "lg",
                                      maxlength: "6",
                                      required: ""
                                    },
                                    on: {
                                      input: _vm.validateContinueCode,
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.searchExistingCredentialing(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.continueCode,
                                      callback: function($$v) {
                                        _vm.continueCode = $$v
                                      },
                                      expression: "continueCode"
                                    }
                                  }),
                                  _c("b-form-invalid-feedback", [
                                    _vm._v(
                                      " Código de 6 dígitos é obrigatório "
                                    )
                                  ]),
                                  _c("b-form-valid-feedback", [
                                    _vm._v(" Código válido ")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "text-center mb-3" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "px-4",
                              class: !_vm.primaryVariant
                                ? "btn-dynamic-primary"
                                : "",
                              style: _vm.modalButtonStyles,
                              attrs: {
                                variant: _vm.primaryVariant,
                                size: "lg",
                                disabled:
                                  !_vm.canSearchCredentialing ||
                                  _vm.searchingCredentialing
                              },
                              on: { click: _vm.searchExistingCredentialing }
                            },
                            [
                              _vm.searchingCredentialing
                                ? _c("b-spinner", {
                                    staticClass: "mr-2",
                                    attrs: { small: "" }
                                  })
                                : _c("i", {
                                    staticClass: "feather icon-search mr-2"
                                  }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.searchingCredentialing
                                      ? "Buscando..."
                                      : "Buscar Credenciamento"
                                  ) +
                                  " "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-alert",
                        {
                          staticClass: "mt-3",
                          attrs: { variant: "info", show: "" }
                        },
                        [
                          _c("div", { staticClass: "alert-body" }, [
                            _c("small", [
                              _c("strong", [_vm._v("Dica:")]),
                              _vm._v(
                                ' O código de credenciamento é enviado por e-mail quando você inicia o processo. Se você não possui o código, inicie um novo credenciamento clicando em "Iniciar Credenciamento". '
                              )
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "text-center mt-4" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "px-3",
                          attrs: { variant: "outline-secondary", size: "sm" },
                          on: { click: _vm.closeModal }
                        },
                        [
                          _c("i", { staticClass: "feather icon-x mr-1" }),
                          _vm._v(" Fechar ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  attrs: {
                    title: "Iniciar Credenciamento",
                    size: "md",
                    "hide-footer": ""
                  },
                  on: {
                    cancel: _vm.resetStartModal,
                    hide: _vm.resetStartModal
                  },
                  model: {
                    value: _vm.showStartModal,
                    callback: function($$v) {
                      _vm.showStartModal = $$v
                    },
                    expression: "showStartModal"
                  }
                },
                [
                  _c("div", { staticClass: "text-center mb-3" }, [
                    _c("i", {
                      staticClass: "feather icon-mail",
                      class: _vm.primaryVariant
                        ? "text-" + _vm.primaryVariant
                        : "text-dynamic-primary",
                      staticStyle: { "font-size": "2.5rem" }
                    }),
                    _c("h5", { staticClass: "mt-3" }, [
                      _vm._v("Verificação de E-mail")
                    ]),
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v(
                        " Informe seu e-mail para receber o código de validação "
                      )
                    ])
                  ]),
                  _vm.codeSent && _vm.generatedCode
                    ? _c(
                        "b-alert",
                        {
                          staticClass: "mb-4",
                          attrs: { variant: "success", show: "" }
                        },
                        [
                          _c("div", { staticClass: "alert-body" }, [
                            _c("h6", { staticClass: "alert-heading" }, [
                              _c("i", {
                                staticClass: "feather icon-check-circle mr-1"
                              }),
                              _vm._v(" Código enviado! ")
                            ]),
                            _c("hr"),
                            _c("p", { staticClass: "mb-2" }, [
                              _vm._v(
                                " Um código de validação foi enviado para "
                              ),
                              _c("strong", [_vm._v(_vm._s(_vm.startEmail))])
                            ]),
                            _c("p", { staticClass: "mb-0" }, [
                              _c("small", [
                                _c("strong", [
                                  _vm._v("Código de validação gerado:")
                                ]),
                                _vm._v(" " + _vm._s(_vm.generatedCode))
                              ])
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.sendVerificationCode($event)
                        }
                      }
                    },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "E-mail",
                            "label-for": "start-email",
                            description:
                              "Este e-mail será usado durante todo o processo de credenciamento e não poderá ser alterado posteriormente"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "start-email",
                              type: "email",
                              placeholder: "seu@email.com",
                              state: _vm.startEmailValidation,
                              size: "lg",
                              required: ""
                            },
                            on: {
                              input: _vm.validateStartEmail,
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.sendVerificationCode($event)
                              }
                            },
                            model: {
                              value: _vm.startEmail,
                              callback: function($$v) {
                                _vm.startEmail = $$v
                              },
                              expression: "startEmail"
                            }
                          }),
                          _c("b-form-invalid-feedback", [
                            _vm._v(" E-mail válido é obrigatório ")
                          ]),
                          _c("b-form-valid-feedback", [
                            _vm._v(" E-mail válido ")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "text-center mb-3" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "px-4",
                              class: !_vm.primaryVariant
                                ? "btn-dynamic-primary"
                                : "",
                              style: _vm.modalButtonStyles,
                              attrs: {
                                variant: _vm.primaryVariant,
                                size: "lg",
                                disabled:
                                  !_vm.isStartEmailValid || _vm.sendingCode
                              },
                              on: { click: _vm.sendVerificationCode }
                            },
                            [
                              _vm.sendingCode
                                ? _c("b-spinner", {
                                    staticClass: "mr-2",
                                    attrs: { small: "" }
                                  })
                                : _c("i", {
                                    staticClass: "feather icon-send mr-2"
                                  }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.sendingCode
                                      ? "Iniciando..."
                                      : "Iniciar preenchimento"
                                  ) +
                                  " "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.codeSent
                        ? _c(
                            "div",
                            { staticClass: "text-center mb-3" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "px-4",
                                  class: !_vm.primaryVariant
                                    ? "btn-dynamic-primary"
                                    : "",
                                  style: _vm.modalButtonStyles,
                                  attrs: {
                                    variant: _vm.primaryVariant,
                                    size: "lg"
                                  },
                                  on: { click: _vm.startCredentialingProcess }
                                },
                                [
                                  _c("i", {
                                    staticClass: "feather icon-arrow-right mr-2"
                                  }),
                                  _vm._v(" Prosseguir com Credenciamento ")
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "b-alert",
                        {
                          staticClass: "mt-3",
                          attrs: { variant: "info", show: "" }
                        },
                        [
                          _c("div", { staticClass: "alert-body" }, [
                            _c("small", [
                              _c("strong", [_vm._v("Importante:")]),
                              _vm._v(
                                " Vai ser gerado um código de validação o qual será necessário para recuperar seus dados caso precise continuar o credenciamento posteriormente. "
                              ),
                              !_vm.codeSent
                                ? _c("span", [
                                    _vm._v(
                                      ' Após inserir seu e-mail, clique em "Iniciar Credenciamento" para receber o código por e-mail.'
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      " Se alterar o e-mail, um novo código será gerado."
                                    )
                                  ])
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "text-center mt-4" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "px-3",
                          attrs: { variant: "outline-secondary", size: "sm" },
                          on: { click: _vm.closeStartModal }
                        },
                        [
                          _c("i", { staticClass: "feather icon-x mr-1" }),
                          _vm._v(" Fechar ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  attrs: {
                    title: "Solicitação Enviada!",
                    size: "md",
                    "hide-footer": ""
                  },
                  on: { hide: _vm.resetForm, cancel: _vm.resetForm },
                  model: {
                    value: _vm.showSuccessModal,
                    callback: function($$v) {
                      _vm.showSuccessModal = $$v
                    },
                    expression: "showSuccessModal"
                  }
                },
                [
                  _c("div", { staticClass: "text-center" }, [
                    _c("i", {
                      staticClass: "feather icon-check-circle text-success",
                      staticStyle: { "font-size": "3rem" }
                    }),
                    _c("h5", { staticClass: "mt-3" }, [_vm._v("Sucesso!")]),
                    _c("p", [
                      _vm._v(
                        "Sua solicitação foi enviada com sucesso. Você receberá um email de confirmação em breve."
                      )
                    ]),
                    _c("p", { staticClass: "text-primary" }, [
                      _vm._v("Protocolo gerado: " + _vm._s(_vm.protocolNumber))
                    ]),
                    _c("small", [
                      _vm._v(
                        "Obrigado por utilizar o sistema de credenciamento CEBAS da SECURAMDATA."
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-4" },
                      [
                        _c(
                          "b-button",
                          {
                            class: _vm.primaryVariant
                              ? "btn-" + _vm.primaryVariant
                              : "btn-dynamic-primary",
                            attrs: { size: "md" },
                            on: { click: _vm.closeSuccessModal }
                          },
                          [
                            _c("i", { staticClass: "feather icon-check mr-2" }),
                            _vm._v(" Fechar ")
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c("AccessibilityPanel", {
                attrs: { "primary-color": _vm.primaryColor }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }